import { render, staticRenderFns } from "./navbar2.vue?vue&type=template&id=1d393766&scoped=true&"
import script from "./navbar2.vue?vue&type=script&lang=js&"
export * from "./navbar2.vue?vue&type=script&lang=js&"
import style0 from "./navbar2.vue?vue&type=style&index=0&id=1d393766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d393766",
  null
  
)

export default component.exports